export default "__VITE_ASSET__8f7f6d2a__"